import { render, staticRenderFns } from "./account-overview.vue?vue&type=template&id=036b61b8&scoped=true&"
import script from "./account-overview.vue?vue&type=script&lang=js&"
export * from "./account-overview.vue?vue&type=script&lang=js&"
import style0 from "./account-overview.vue?vue&type=style&index=0&id=036b61b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b61b8",
  null
  
)

export default component.exports